import { defineMessages } from 'react-intl';
export var Action = defineMessages({
  Back: {
    id: 'Action_Back',
    defaultMessage: 'Back'
  },
  UpdateProfile: {
    id: 'Action_UpdateProfile',
    defaultMessage: 'Update profile'
  },
  ChangeAvatar: {
    id: 'Action_ChangeAvatar',
    defaultMessage: 'Change avatar'
  },
  ChangePassword: {
    id: 'Action_ChangePassword',
    defaultMessage: 'Change password'
  },
  RegenaratePin: {
    id: 'Action_RegenaratePin',
    defaultMessage: 'Regenarate PIN'
  },
  ChangeThumbnail: {
    id: 'Action_ChangeThumbnail',
    defaultMessage: 'Change tumbnail'
  },
  ResetPassword: {
    id: 'Action_ResetPassword',
    defaultMessage: 'Reset password'
  },
  Clear: {
    id: 'Action_Clear',
    defaultMessage: 'Clear'
  },
  Default: {
    id: 'Action_Default',
    defaultMessage: 'Default'
  },
  Delete: {
    id: 'Action_Delete',
    defaultMessage: 'Delete'
  },
  Entry: {
    id: 'Action_Entry',
    defaultMessage: 'Submit'
  },
  Invitation: {
    id: 'Action_Invitation',
    defaultMessage: 'Invite'
  },
  Login: {
    id: 'Action_Login',
    defaultMessage: 'Login'
  },
  Search: {
    id: 'Action_Search',
    defaultMessage: 'Search'
  },
  ConditionSearch: {
    id: 'Action_ConditionSearch',
    defaultMessage: 'Search'
  },
  ConditionReport: {
    id: 'Action_ConditionReport',
    defaultMessage: 'Report'
  },
  Modify: {
    id: 'Action_Modify',
    defaultMessage: 'Edit'
  },
  Update: {
    id: 'Action_Update',
    defaultMessage: 'Update'
  },
  Upload: {
    id: 'Action_Upload',
    defaultMessage: 'Upload'
  },
  ReEntry: {
    id: 'Action_ReEntry',
    defaultMessage: 'Re-submit'
  },
  Retry: {
    id: 'Action_Retry',
    defaultMessage: 'Retry'
  },
  SendMail: {
    id: 'Action_SendMail',
    defaultMessage: 'Send invite'
  },
  ResendMail: {
    id: 'Action_ResendMail',
    defaultMessage: 'Resend invite'
  },
  MailSent: {
    id: 'Action_MailSent',
    defaultMessage: 'Invite sent'
  },
  Reset: {
    id: 'Action_Reset',
    defaultMessage: 'Reset'
  },
  Adjust: {
    id: 'Action_Adjust',
    defaultMessage: 'Adjust'
  },
  Refresh: {
    id: 'Action_Refresh',
    defaultMessage: 'Refresh'
  },
  Close: {
    id: 'Action_Close',
    defaultMessage: 'Close'
  },
  Regenerate: {
    id: 'Action_Regenerate',
    defaultMessage: 'Regenerate'
  },
  ReturnSessionHistory: {
    id: 'Action_ReturnSessionHistory',
    defaultMessage: 'Return to Past Meetings'
  },
  SelectTarget: {
    id: 'Action_SelectTarget',
    defaultMessage: 'Select target'
  },
  SelectTrigger: {
    id: 'Action_SelectTrigger',
    defaultMessage: 'Select trigger'
  },
  SelectAction: {
    id: 'Action_SelectAction',
    defaultMessage: 'Select action'
  },
  SelectMotion: {
    id: 'Action_SelectMotion',
    defaultMessage: 'Select motion'
  },
  SelectPage: {
    id: 'Action_SelectPage',
    defaultMessage: 'Select page'
  },
  SelectScale: {
    id: 'Action_SelectScale',
    defaultMessage: 'Select scale'
  },
  SelectLoop: {
    id: 'Action_SelectLoop',
    defaultMessage: 'Select loop'
  },
  SelectPanel: {
    id: 'Action_SelectPanel',
    defaultMessage: 'Select message'
  },
  SelectSituation: {
    id: 'Action_SelectSituation',
    defaultMessage: 'Select situation'
  },
  SelectIntensity: {
    id: 'Action_SelectIntensity',
    defaultMessage: 'Select intensity'
  },
  SelectTime: {
    id: 'Action_SelectTime',
    defaultMessage: 'Select time'
  },
  SelectScenarioGroup: {
    id: 'Action_SelectScenarioGroup',
    defaultMessage: 'Select destination'
  },
  Edit: {
    id: 'Action_Edit',
    defaultMessage: 'Edit'
  },
  Ignore: {
    id: 'Action_Ignore',
    defaultMessage: 'Ignore'
  },
  Yes: {
    id: 'Action_Yes',
    defaultMessage: 'Yes'
  },
  No: {
    id: 'Action_No',
    defaultMessage: 'No'
  },
  EditSequence: {
    id: 'Action_EditSequence',
    defaultMessage: 'Edit sequence'
  },
  EditInteraction: {
    id: 'Action_EditInteraction',
    defaultMessage: 'Edit interaction'
  },
  AddEmpty: {
    id: 'Action_AddEmpty',
    defaultMessage: 'Add trigger object'
  },
  AddEffect: {
    id: 'Action_AddEffect',
    defaultMessage: 'Add effect'
  },
  AddTextPanel: {
    id: 'Action_AddTextPanel',
    defaultMessage: 'Add text panel'
  },
  ManageMessage: {
    id: 'Action_ManageMessage',
    defaultMessage: 'Manage message'
  },
  AddMessage: {
    id: 'Action_AddMessage',
    defaultMessage: 'Add Message'
  },
  AddDataPanel: {
    id: 'Action_AddDataPanel',
    defaultMessage: 'Add data panel'
  },
  AddButton: {
    id: 'Action_AddButton',
    defaultMessage: 'Add Button'
  },
  Decide: {
    id: 'Action_Decide',
    defaultMessage: 'Decide'
  },
  Change: {
    id: 'Action_Change',
    defaultMessage: 'Change'
  },
  Suspend: {
    id: 'Action_Suspend',
    defaultMessage: 'Suspend'
  },
  Resume: {
    id: 'Action_Resume',
    defaultMessage: 'Resume'
  },
  Ok: {
    id: 'Action_Ok',
    defaultMessage: 'OK'
  },
  Create: {
    id: 'Action_Create',
    defaultMessage: 'Create'
  },
  Add: {
    id: 'Action_Add',
    defaultMessage: 'Add'
  },
  Cancel: {
    id: 'Action_Cancel',
    defaultMessage: 'Cancel'
  },
  Print: {
    id: 'Action_Print',
    defaultMessage: 'Print'
  },
  MemberSelection: {
    id: 'Action_MemberSelection',
    defaultMessage: 'Member selection'
  },
  CancelAdd: {
    id: 'Action_CancelAdd',
    defaultMessage: 'Cancel add'
  },
  CancelEdit: {
    id: 'Action_CancelEdit',
    defaultMessage: 'Cancel edit'
  },
  RegisterContent: {
    id: 'Action_RegisterContent',
    defaultMessage: 'Register with this content'
  },
  DeleteSelectedFile: {
    id: 'Action_DeleteSelectedFile',
    defaultMessage: 'Delete selected file'
  },
  UploadFromOneDrive: {
    id: 'Action_UploadFromOneDrive',
    defaultMessage: 'Upload from OneDrive'
  },
  Duplicate: {
    id: 'Action_Duplicate',
    defaultMessage: 'Duplicate'
  },
  Setting: {
    id: 'Action_Setting',
    defaultMessage: 'Setting'
  },
  Generate: {
    id: 'Action_Generate',
    defaultMessage: 'Generate'
  },
  Terminate: {
    id: 'Action_Terminate',
    defaultMessage: 'Cancel'
  },
  CopyLink: {
    id: 'Action_CopyLink',
    defaultMessage: 'Copy link'
  },
  QRDisplay: {
    id: 'Action_QRDisplay',
    defaultMessage: 'QR display'
  },
  PublishLink: {
    id: 'Action_PublishLink',
    defaultMessage: 'Publish link'
  },
  GenerateLink: {
    id: 'Action_GenerateLink',
    defaultMessage: 'Generate link'
  },
  RemoveLink: {
    id: 'Action_RemoveLink',
    defaultMessage: 'Remove link'
  },
  AddScenarioGroup: {
    id: 'Action_AddScenarioGroup',
    defaultMessage: 'Add scenario group'
  },
  AddParam: {
    id: 'Action_AddParam',
    defaultMessage: 'Add parameter'
  },
  CreateNew: {
    id: 'Action_CreateNew',
    defaultMessage: 'Create new'
  },
  Rename: {
    id: 'Action_Rename',
    defaultMessage: 'Rename'
  },
  Keep: {
    id: 'Action_Keep',
    defaultMessage: 'Keep'
  }
});
export var Errors = defineMessages({
  InputDate: {
    id: 'Error_InputDate',
    defaultMessage: 'Please enter the correct date'
  },
  InputPariod: {
    id: 'Error_InputPariod',
    defaultMessage: 'The end date and time is set before the start date and time'
  },
  InputPastStartDate: {
    id: 'Error_InputPastStartDate',
    defaultMessage: 'Set start date and time after current time'
  },
  InputPastEndDate: {
    id: 'Error_InputPastEndDate',
    defaultMessage: 'Set end date and time after current time'
  },
  InputRequired: {
    id: 'Error_InputRequired',
    defaultMessage: 'Required'
  },
  InputWrongExtention: {
    id: 'Error_InputWrongExtention',
    defaultMessage: 'Select a file with extension {extention}'
  },
  InputWrongFileSize: {
    id: 'Error_InputWrongFileSize',
    defaultMessage: 'File size exceeds {size}'
  },
  InputWrongFormat: {
    id: 'Error_InputWrongFormat',
    defaultMessage: '{title} has the wrong format'
  },
  InputWrongFormatWithValue: {
    id: 'Error_InputWrongFormatWithValue',
    defaultMessage: '{title} has the wrong format ({value})'
  },
  InputWrongMaxLength: {
    id: 'Error_InputWrongMaxLength',
    defaultMessage: '{title} must be within {length} characters'
  },
  DataNotFound: {
    id: 'Error_DataNotFound',
    defaultMessage: 'No {title} found'
  },
  DataNotSelected: {
    id: 'Error_DataNotSelected',
    defaultMessage: 'No {title} selected'
  },
  DataNotMatch: {
    id: 'Error_DataNotMatch',
    defaultMessage: '{title} does not match'
  },
  FileTypeNotSupported: {
    id: 'Error_FileTypeNotSupported',
    defaultMessage: '{ex} is an unsupported data format'
  },
  FileUploadFailed: {
    id: 'Error_FileUploadFailed',
    defaultMessage: 'File upload failed, please close the file if it is open.'
  },
  FileUploadSessionUnselected: {
    id: 'Error_FileUploadSessionUnselected',
    defaultMessage: 'File upload failed. No room selected.'
  },
  FileUploadSessionEnded: {
    id: 'Error_FileUploadSessionEnded',
    defaultMessage: 'File upload failed. The room has ended.'
  },
  ConfirmFileExists: {
    id: 'Error_ConfirmFileExists',
    defaultMessage: 'The following files have already been uploaded.\nDo you want to overwrite?\n'
  },
  ConfirmFileSize: {
    id: 'Error_ConfirmFileSize',
    defaultMessage: 'The upload of the selected files may take some time.\nDo you want to continue with the upload?'
  },
  ConfirmTerrainExists: {
    id: 'Error_ConfirmTerrainExists',
    defaultMessage: ' has already been generated. \nDo you want to overwrite?'
  },
  SessionStorageShortage: {
    id: 'Error_SessionStorageShortage',
    defaultMessage: 'Could not process because it exceeds the storage limit'
  },
  ConversionIsNotComplete: {
    id: 'Error_ConversionIsNotComplete',
    defaultMessage: 'Conversion is in progress. Please wait until it has finished and try again'
  },
  SelectRequired: {
    id: 'Error_SelectRequired',
    defaultMessage: 'Error: Some items are not selected. Please select all items.'
  },
  SameItemsSelected: {
    id: 'Error_SameItemsSelected',
    defaultMessage: 'Error: This trigger cannot select the same item.'
  },
  TriggerSelectionErrorInFirstSequence: {
    id: 'Error_TriggerSelectionErrorInFirstSequence',
    defaultMessage: 'Error: This trigger cannot be selected for the first sequence.'
  },
  BothInputRequired: {
    id: 'Error_BothInputRequired',
    defaultMessage: 'If {item1} is set, {item2} must also be set'
  },
  DateInput3ItemsPariod: {
    id: 'Error_DateInput3ItemsPariod',
    defaultMessage: 'Dates are reversed. Please set them to be in the order {item1}, {item2}, {item3}.'
  },
  DateInput2ItemsPariod: {
    id: 'Error_DateInput2ItemsPariod',
    defaultMessage: 'Dates are reversed. Please set them to be in the order {item1}, {item2}.'
  },
  DuplicateContractPeriods: {
    id: 'Error_DuplicateContractPeriods',
    defaultMessage: 'There are duplicate contract periods.'
  },
  DuplicateSequenceGroupName: {
    id: 'Error_DuplicateSequenceGroupName',
    defaultMessage: 'A scenario group with the same name is already registered.'
  }
});
export var Description = defineMessages({
  InputDescriptionFileSize: {
    id: 'Description_InputDescriptionFileSize',
    defaultMessage: 'Uploadable size: {size} or less'
  },
  ActionDescriptionResetPassword: {
    id: 'Description_ActionDescriptionResetPassword',
    defaultMessage: 'Reset password for {name}'
  },
  ActionDescriptionRegeneratePin: {
    id: 'Description_ActionDescriptionRegeneratePin',
    defaultMessage: 'Regenerate PIN'
  },
  PlacementQrCodeDescription: {
    id: 'Description_PlacementQrCodeDescription',
    defaultMessage: 'Place the QR code where you want the object to appear'
  },
  PlacementQrCodeDescriptionPrint: {
    id: 'Description_PlacementQrCodeDescriptionPrint',
    defaultMessage: 'Print this page and place it where you want the object to appear'
  },
  ConfirmNavigationWarning: {
    id: 'Description_ConfirmNavigationWarning',
    defaultMessage: 'Are you sure you want to leave this site? If you leave, your information will be lost.'
  }
});
export var Label = defineMessages({
  Authority: {
    id: 'Label_Authority',
    defaultMessage: 'Access level'
  },
  Avatar: {
    id: 'Label_Avatar',
    defaultMessage: 'Avatar'
  },
  Thumbnail: {
    id: 'Label_Thumbnail',
    defaultMessage: 'Thumbnail'
  },
  Capture: {
    id: 'Label_Capture',
    defaultMessage: 'Capture'
  },
  Date: {
    id: 'Label_Date',
    defaultMessage: 'Date'
  },
  EndDate: {
    id: 'Label_EndDate',
    defaultMessage: 'End date'
  },
  Extension: {
    id: 'Label_Extension',
    defaultMessage: 'Extension'
  },
  Group: {
    id: 'Label_Group',
    defaultMessage: 'Group'
  },
  GroupName: {
    id: 'Label_GroupName',
    defaultMessage: 'Group name'
  },
  LastModified: {
    id: 'Label_LastModified',
    defaultMessage: 'Last modified'
  },
  Latitude: {
    id: 'Label_Latitude',
    defaultMessage: 'Latitude'
  },
  Level: {
    id: 'Label_Level',
    defaultMessage: 'Level'
  },
  Longitude: {
    id: 'Label_Longitude',
    defaultMessage: 'Longitude'
  },
  MailAddress: {
    id: 'Label_MailAddress',
    defaultMessage: 'Mail address'
  },
  Member: {
    id: 'Label_Member',
    defaultMessage: 'Member'
  },
  Name: {
    id: 'Label_Name',
    defaultMessage: 'Name'
  },
  CurrentPassword: {
    id: 'Label_CurrentPassword',
    defaultMessage: 'Current password'
  },
  Password: {
    id: 'Label_Password',
    defaultMessage: 'Password'
  },
  Pin: {
    id: 'Label_Pin',
    defaultMessage: 'PIN'
  },
  Rate: {
    id: 'Label_Rate',
    defaultMessage: 'Display mode'
  },
  Reduction: {
    id: 'Label_Reduction',
    defaultMessage: 'Reduction'
  },
  RePassword: {
    id: 'Label_RePassword',
    defaultMessage: 'Confirm password'
  },
  SessionName: {
    id: 'Label_SessionName',
    defaultMessage: 'Session name'
  },
  Situation: {
    id: 'Label_Situation',
    defaultMessage: 'Status'
  },
  Size: {
    id: 'Label_Size',
    defaultMessage: 'Size'
  },
  StartDate: {
    id: 'Label_StartDate',
    defaultMessage: 'Start date'
  },
  Template: {
    id: 'Label_Template',
    defaultMessage: 'Past meetings'
  },
  UserName: {
    id: 'Label_UserName',
    defaultMessage: 'User name'
  },
  RecordDate: {
    id: 'Label_RecordDate',
    defaultMessage: 'Record date'
  },
  Memo: {
    id: 'Label_Memo',
    defaultMessage: 'Memo'
  },
  RoomId: {
    id: 'Label_RoomId',
    defaultMessage: 'ROOM ID'
  },
  RoomName: {
    id: 'Label_RoomName',
    defaultMessage: 'Room name'
  },
  Share: {
    id: 'Label_Share',
    defaultMessage: 'Allow Download'
  },
  Lighting: {
    id: 'Label_Lighting',
    defaultMessage: 'Shadow'
  },
  OrganizationId: {
    id: 'Label_OrganizationId',
    defaultMessage: 'Organization id'
  },
  OrganizationName: {
    id: 'Label_OrganizationName',
    defaultMessage: 'Organization name'
  },
  Domain: {
    id: 'Label_Domain',
    defaultMessage: 'Domain'
  },
  UserMaxCount: {
    id: 'Label_UserMaxCount',
    defaultMessage: 'Maximum number of registered users'
  },
  GuestMaxCount: {
    id: 'Label_GuestMaxCount',
    defaultMessage: 'Maximum number of registered guests'
  },
  ServiceType: {
    id: 'Label_ServiceType',
    defaultMessage: 'Service type'
  },
  ProtocolType: {
    id: 'Label_ProtocolType',
    defaultMessage: 'Protocol type'
  },
  Status: {
    id: 'Label_Status',
    defaultMessage: 'Status'
  },
  LastSaveDate: {
    id: 'Label_LastSaveDate',
    defaultMessage: 'Last save date'
  },
  Title: {
    id: 'Label_Title',
    defaultMessage: 'Title'
  },
  Contents: {
    id: 'Label_Contents',
    defaultMessage: 'Contents'
  },
  Invited: {
    id: 'Label_Invited',
    defaultMessage: 'Invited'
  },
  Unregistered: {
    id: 'Label_Unregistered',
    defaultMessage: 'Unregistered'
  },
  InformationScope: {
    id: 'Label_InformationScope',
    defaultMessage: 'Notification destination'
  },
  Support: {
    id: 'Label_Support',
    defaultMessage: 'Support'
  },
  CanSupport: {
    id: 'Label_CanSupport',
    defaultMessage: 'Can support'
  },
  PublishDate: {
    id: 'Label_PublishDate',
    defaultMessage: 'Publish date'
  },
  Sequence: {
    id: 'Label_Sequence',
    defaultMessage: 'Sequence'
  },
  Interaction: {
    id: 'Label_Interaction',
    defaultMessage: 'Interaction'
  },
  TriggerObject: {
    id: 'Label_TriggerObject',
    defaultMessage: 'Trigger object'
  },
  TriggerAction: {
    id: 'Label_TriggerAction',
    defaultMessage: 'Trigger action'
  },
  TargetObject: {
    id: 'Label_TargetObject',
    defaultMessage: 'Target object'
  },
  TargetAction: {
    id: 'Label_TargetAction',
    defaultMessage: 'Target action'
  },
  TargetOption: {
    id: 'Label_TargetOption',
    defaultMessage: 'Target option'
  },
  Loop: {
    id: 'Label_Loop',
    defaultMessage: 'Loop'
  },
  Effect: {
    id: 'Label_Effect',
    defaultMessage: 'Effect'
  },
  SceneSelection: {
    id: 'Label_SceneSelection',
    defaultMessage: 'Scene selection'
  },
  SearchStartDate: {
    id: 'Label_SearchStartDate',
    defaultMessage: 'Search start date'
  },
  SearchEndDate: {
    id: 'Label_SearchEndDate',
    defaultMessage: 'Search end date'
  },
  MailNotified: {
    id: 'Label_MailNotified',
    defaultMessage: 'Mail notified'
  },
  Setting: {
    id: 'Label_Setting',
    defaultMessage: 'Setting'
  },
  PhotonSetting: {
    id: 'Label_PhotonSetting',
    defaultMessage: 'Photon setting'
  },
  LiveOption: {
    id: 'Label_LiveOption',
    defaultMessage: 'WHITEROOM LIVE'
  },
  RemoteSupportOption: {
    id: 'Label_RemoteSupportOption',
    defaultMessage: 'Remote support'
  },
  StreamingOption: {
    id: 'Label_StreamingOption',
    defaultMessage: 'SphereCast'
  },
  PcVrOption: {
    id: 'Label_PcVrOption',
    defaultMessage: 'PCVR'
  },
  ChatBotOption: {
    id: 'Label_ChatBotOption',
    defaultMessage: 'ChatBot'
  },
  TranslationOption: {
    id: 'Label_TranslationOption',
    defaultMessage: 'Translation'
  },
  EffectOption: {
    id: 'Label_EffectOption',
    defaultMessage: 'Effect'
  },
  LargeCapacityOption: {
    id: 'Label_LargeCapacityOption',
    defaultMessage: 'Large Capacity'
  },
  DataIntegrationOption: {
    id: 'Label_DataIntegrationOption',
    defaultMessage: 'Data Integration'
  },
  SplatOption: {
    id: 'Label_SplatOption',
    defaultMessage: '3DGS'
  },
  MapOption: {
    id: 'Label_MapOption',
    defaultMessage: '3DGS Map'
  },
  FullbodyAvatarOption: {
    id: 'Label_FullbodyAvatarOption',
    defaultMessage: 'Fullbody Avatar'
  },
  Total: {
    id: 'Label_Total',
    defaultMessage: 'Total'
  },
  TrialStartDate: {
    id: 'Label_TrialStartDate',
    defaultMessage: 'Trial start date'
  },
  PaidStartDate: {
    id: 'Label_PaidStartDate',
    defaultMessage: 'Paid start date'
  },
  ContractEndDate: {
    id: 'Label_ContractEndDate',
    defaultMessage: 'Contract end date'
  },
  Latest: {
    id: 'Label_Latest',
    defaultMessage: 'Latest'
  },
  New: {
    id: 'Label_New',
    defaultMessage: 'New'
  },
  ContractManager: {
    id: 'Label_ContractManager',
    defaultMessage: 'Contract manager'
  },
  Period: {
    id: 'Label_Period',
    defaultMessage: 'Period'
  },
  LastModifiedDatetime: {
    id: 'Label_LastModifiedDatetime',
    defaultMessage: 'Last update'
  },
  UseEverywhere: {
    id: 'Label_UseEverywhere',
    defaultMessage: 'Everywhere'
  },
  UseOneDrive: {
    id: 'Label_UseOneDrive',
    defaultMessage: 'OneDrive usage'
  },
  ClientId: {
    id: 'Label_ClientId',
    defaultMessage: 'Application ID'
  },
  Destination: {
    id: 'Label_Destination',
    defaultMessage: 'Destination'
  },
  Explanation: {
    id: "Label_Explanation",
    defaultMessage: "Explanation"
  },
  Correct: {
    id: "Label_Correct",
    defaultMessage: "Correct"
  },
  Seconds: {
    id: 'Label_Seconds',
    defaultMessage: '{time} seconds'
  },
  StreamingLocation: {
    id: 'Label_StreamingLocation',
    defaultMessage: 'Streaming location'
  },
  StreamingStatus: {
    id: 'Label_StreamingStatus',
    defaultMessage: 'Streaming status'
  },
  StreamingUrl: {
    id: 'Label_StreamingUrl',
    defaultMessage: 'Streaming url'
  },
  RemainingStreamingTime: {
    id: 'Label_RemainingStreamingTime',
    defaultMessage: 'Remaining streaming time'
  },
  SpecifyPeriod: {
    id: 'Label_SpecifyPeriod',
    defaultMessage: 'Set the end date and time'
  },
  IndefiniteDuration: {
    id: 'Label_IndefiniteDuration',
    defaultMessage: 'Indefinite'
  },
  DataAcquisitionSource: {
    id: 'Label_DataAcquisitionSource',
    defaultMessage: 'Data acquisition source'
  },
  OptionParameter: {
    id: 'Label_OptionParameter',
    defaultMessage: 'Parameter (Optional)'
  },
  LoginInfo: {
    id: 'Label_LoginInfo',
    defaultMessage: 'Login info'
  },
  AcquisitionFrequency: {
    id: 'Label_AcquisitionFrequency',
    defaultMessage: 'Acquisition frequency'
  },
  PrivateMode: {
    id: 'Label_PrivateMode',
    defaultMessage: 'Private'
  },
  EditScenarioGroup: {
    id: 'Label_EditScenarioGroup',
    defaultMessage: 'Editing scenario group'
  },
  DuplicateSource: {
    id: 'Label_DuplicateSource',
    defaultMessage: 'Duplication source'
  },
  IsBranch: {
    id: 'Label_IsBranch',
    defaultMessage: 'Branch based on response'
  },
  PlaybackMode: {
    id: 'Label_PlaybackMode',
    defaultMessage: 'Viewing mode'
  },
  Files: {
    id: 'Label_Files',
    defaultMessage: '{count} file(s)'
  }
});
export var Login = defineMessages({
  Title: {
    id: 'Login_Title',
    defaultMessage: 'Login'
  }
});
export var Organizations = defineMessages({
  Title: {
    id: 'Organizations_Title',
    defaultMessage: 'Organizations'
  }
});
export var Organization = defineMessages({
  Title: {
    id: 'Organization_Title',
    defaultMessage: 'Organization'
  },
  DomainDescription: {
    id: 'Organization_DomainDescription',
    defaultMessage: 'Multiple inputs are possible (comma separated)'
  },
  Contract: {
    id: 'Organizations_Contract',
    defaultMessage: 'Contract'
  },
  DeleteConfirmMessage: {
    id: 'Organization_DeleteConfirmMessage',
    defaultMessage: 'Are you sure you want to delete {name} ?'
  },
  SuspendConfirmMessage: {
    id: 'Organization_SuspendConfirmMessage',
    defaultMessage: 'Are you sure you want to suspend {name} ?'
  },
  ResumeConfirmMessage: {
    id: 'Organization_ResumeConfirmMessage',
    defaultMessage: 'Are you sure you want to resume {name} ?'
  },
  UnregisteredConfirmMessage: {
    id: 'Organization_UnregisteredConfirmMessage',
    defaultMessage: 'Transitioning while the modifications have not been reflected?'
  },
  DeleteContractConfirmMessage: {
    id: 'Organization_DeleteContractConfirmMessage',
    defaultMessage: 'Deletes the currently displayed contract.'
  }
});
export var Members = defineMessages({
  Title: {
    id: 'Members_Title',
    defaultMessage: 'Members'
  }
});
export var Password = defineMessages({
  Title: {
    id: 'Password_Title',
    defaultMessage: 'Password'
  }
});
export var Offset = defineMessages({
  Title: {
    id: 'Offset_Title',
    defaultMessage: 'Place assets using QR code'
  },
  OffsetMessage: {
    id: 'Offset_OffsetMessage',
    defaultMessage: 'By recognizing the created QR code with the app, you can place the assets in the same position every time. Additionally, it is also possible to set an offset from the QR code during this process.'
  },
  OffsetTitle: {
    id: 'Offset_OffsetTitle',
    defaultMessage: 'Title(Required)'
  },
  OffsetValueTitle: {
    id: 'Offset_OffsetValueTitle',
    defaultMessage: 'Offset[mm]'
  }
});
export var Print = defineMessages({
  Title: {
    id: 'Print_Title',
    defaultMessage: 'Print'
  },
  NoCodeMessage: {
    id: 'Print_NoCodeMessage',
    defaultMessage: 'QR code is missing'
  }
});
export var Profile = defineMessages({
  Title: {
    id: 'Profile_Title',
    defaultMessage: 'Profile'
  }
});
export var QRCodes = defineMessages({
  Title: {
    id: 'QRCode_Title',
    defaultMessage: 'Join via QR code'
  },
  JoinTitle: {
    id: 'QRCode_JoinTitle',
    defaultMessage: 'Join the room'
  },
  HelpTitle_iPhone_iPad: {
    id: 'QRCode_HelpTitle_iPhone_iPad',
    defaultMessage: '- If joining from an iPhone / iPad'
  },
  HelpMessage_iPhone_iPad: {
    id: 'QRCode_HelpMessage_iPhone_iPad',
    defaultMessage: 'Launch the app from the link below, select from the list of rooms, and enter.'
  },
  HelpLink_iPhone_iPad: {
    id: 'QRCode_HelpLink_iPhone_iPad',
    defaultMessage: 'Launch App'
  },
  HelpTitle_Windows_Quest: {
    id: 'QRCode_HelpTitle_Windows_Quest',
    defaultMessage: '- If joining from a Windows PC / Meta Quest'
  },
  HelpMessage_Windows_Quest: {
    id: 'QRCode_HelpMessage_Windows_Quest',
    defaultMessage: 'After launching the app and logging in, select from the list of rooms and enter.'
  },
  HelpTitle_HoloLens: {
    id: 'QRCode_HelpTitle_HoloLens',
    defaultMessage: '- If joining from HoloLens'
  },
  HelpMessage_HoloLens: {
    id: 'QRCode_HelpMessage_HoloLens',
    defaultMessage: 'Once the app is launched, scan the QR code mentioned on the right and in the invitation email, and enter the PIN code.'
  },
  HelpTitle_Install: {
    id: 'QRCode_HelpTitle_Install',
    defaultMessage: '- If you have not yet installed the app'
  },
  HelpMessage_Install: {
    id: 'QRCode_HelpMessage_Install',
    defaultMessage: 'Please refer to the following to install the app.'
  },
  QRTitle: {
    id: 'QRCode_QRTitle',
    defaultMessage: 'Participation QR code for HoloLens'
  },
  QRDescription: {
    id: 'QRCode_QRDescription',
    defaultMessage: 'If you cannot enter the room with the QR code, you can also enter from the following room ID.'
  }
});
export var CreateSession = defineMessages({
  Title: {
    id: 'CreateSession_Title',
    defaultMessage: 'Create room'
  },
  EditTitle: {
    id: 'CreateSession_EditTitle',
    defaultMessage: 'Edit room'
  },
  ViewTitle: {
    id: 'CreateSession_ViewTitle',
    defaultMessage: 'View room'
  },
  CreateFromEmpty: {
    id: 'CreateSession_CreateFromEmpty',
    defaultMessage: 'New empty meeting'
  },
  CreateFromPastMeeting: {
    id: 'CreateSession_CreateFromPastMeeting',
    defaultMessage: 'Copy past meeting'
  }
});
export var ModifySession = defineMessages({
  Title: {
    id: 'ModifySession_Title',
    defaultMessage: 'Modify room'
  }
});
export var ReadonlySession = defineMessages({
  Title: {
    id: 'ReadonlySession_Title',
    defaultMessage: 'Room details'
  }
});
export var ResourceUpload = defineMessages({
  Title: {
    id: 'ResourceUpload_Title',
    defaultMessage: 'Upload files'
  }
});
export var ReductionRate = defineMessages({
  Title: {
    id: 'ReductionRate_Title',
    defaultMessage: 'Display mode of point cloud data'
  },
  TipsTopics: {
    id: 'ReductionRate_TipsTopics',
    defaultMessage: 'Tips : When participating on a PC or VRPlus, up to 80 million vertices can be displayed per file in HD mode, and up to 40 million vertices in SD mode.'
  },
  TipsNotes_1: {
    id: 'ReductionRate_TipsNotes_1',
    defaultMessage: '*The vertices that exceed the limit will not be displayed, so some of the shape may appear distorted.'
  },
  TipsNotes_2: {
    id: 'ReductionRate_TipsNotes_2',
    defaultMessage: '*When Meta Quest is displayed by itself, up to 60,000 vertices can be displayed in either mode.'
  },
  TipsNotes_3: {
    id: 'ReductionRate_TipsNotes_3',
    defaultMessage: '*When displayed on iPhone/iPad, up to 1.8 million vertices can be displayed in any mode.'
  },
  OptionsNormal: {
    id: 'ReductionRate_OptionsNormal',
    defaultMessage: 'SD'
  },
  OptionsHighDensity: {
    id: 'ReductionRate_OptionsHighDensity',
    defaultMessage: 'HD'
  }
});
export var PlaybackMode = defineMessages({
  Title: {
    id: 'PlaybackMode_Title',
    defaultMessage: 'Video/audio file viewing mode'
  },
  Download: {
    id: 'PlaybackMode_Download',
    defaultMessage: 'Download'
  },
  Streaming: {
    id: 'PlaybackMode_Streaming',
    defaultMessage: 'Streaming'
  },
  DisplayDownload: {
    id: 'PlaybackMode_DisplayDownload',
    defaultMessage: 'Download and play (standard)'
  },
  DisplayStreaming: {
    id: 'PlaybackMode_DisplayStreaming',
    defaultMessage: 'Streaming playback'
  },
  TipsTopics: {
    id: 'PlaybackMode_TipsTopics',
    defaultMessage: 'Tips: For large video/audio files, we recommend using "Streaming playback".'
  }
});
export var SessionHistoriesEditMemo = defineMessages({
  Title: {
    id: 'SessionHistoriesEditMemo_Title',
    defaultMessage: 'Memo'
  }
});
export var Session = defineMessages({
  Title: {
    id: 'Session_Title',
    defaultMessage: 'Meeting'
  },
  SearchingHistory: {
    id: 'Session_SearchingHistory',
    defaultMessage: 'Searching past meetings...'
  }
});
export var SessionConfirm = defineMessages({
  SessionDeleteConfirmTitle: {
    id: 'SessionConfirm_ConfirmTitle',
    defaultMessage: 'Confirm Room Deletion'
  },
  SessionDeleteConfirmMessage: {
    id: 'SessionConfirm_ConfirmMessage',
    defaultMessage: 'If you delete the room, it will also be removed from the room history and cannot be reopened.\nis it OK?'
  }
});
export var SessionHistories = defineMessages({
  Title: {
    id: 'SessionHistories_Title',
    defaultMessage: 'Past meetings'
  },
  SearchingHistory: {
    id: 'SessionHistories_SearchingHistory',
    defaultMessage: 'Searching past meetings...'
  },
  NoHistory: {
    id: 'SessionHistories_NoHistory',
    defaultMessage: 'No past meetings.'
  },
  Keyword: {
    id: 'SessionHistories_Keyword',
    defaultMessage: 'Keyword'
  },
  SearchWord: {
    id: 'SessionHistories_SearchWord',
    defaultMessage: 'Meeting name, participant name, memo, etc.'
  },
  TimeAndDate: {
    id: 'SessionHistories_TimeAndDate',
    defaultMessage: 'Time & Date'
  },
  Organizer: {
    id: 'SessionHistories_Organizer',
    defaultMessage: 'Organizer : {name}'
  },
  Paticipant: {
    id: 'SessionHistories_Paticipant',
    defaultMessage: 'Paticipant : {name}'
  },
  DownloadReport: {
    id: 'SessionHistories_DownloadReport',
    defaultMessage: 'Download CSV（β）'
  },
  DetailView: {
    id: 'SessionHistories_DetailView',
    defaultMessage: 'Detail View'
  },
  Recorder: {
    id: 'SessionHistories_Recorder',
    defaultMessage: 'Recorder : {name}'
  },
  RecordingDate: {
    id: 'SessionHistories_RecordingDate',
    defaultMessage: 'Recording date : {date}'
  },
  Sharer: {
    id: 'SessionHistories_Sharer',
    defaultMessage: 'Sharer : {name}'
  },
  SharedDate: {
    id: 'SessionHistories_SharedDate',
    defaultMessage: 'Shared date : {date}'
  },
  Memo: {
    id: 'SessionHistories_Memo',
    defaultMessage: 'Memo'
  },
  MemoNotFound: {
    id: 'SessionHistories_MemoNotFound',
    defaultMessage: 'No memo'
  },
  CaptureMemoNotFound: {
    id: 'SessionHistories_CaptureMemoNotFound',
    defaultMessage: 'No memo or capture'
  },
  CaptureDelete: {
    id: 'SessionHistories_CaptureDelete',
    defaultMessage: 'Delete'
  },
  SetSceneThumbnail: {
    id: 'SessionHistories_SetSceneThumbnail',
    defaultMessage: 'Set as Room Thumbnail'
  },
  ClearSceneThumbnail: {
    id: 'SessionHistories_ClearSceneThumbnail',
    defaultMessage: 'Remove Room Thumbnail'
  },
  MoreCaptures: {
    id: 'SessionHistories_MoreCaptures',
    defaultMessage: 'and {number} more'
  }
});
export var Sessions = defineMessages({
  IncludePastMeetings: {
    id: 'Sessions_IncludePastMeetings',
    defaultMessage: 'Show ended rooms'
  },
  MyMeeting: {
    id: 'Sessions_MyMeeting',
    defaultMessage: 'My Rooms'
  },
  ShareMeeting: {
    id: 'Sessions_ShareMeeting',
    defaultMessage: 'Shared with me'
  },
  OthersMeeting: {
    id: 'Sessions_OthersMeeting',
    defaultMessage: 'Not Shared with me'
  },
  TemplateOptionsNone: {
    id: 'Sessions_TemplateOptionsNone',
    defaultMessage: 'Please select a meeting'
  },
  UseState: {
    id: 'Sessions_UseState',
    defaultMessage: 'Keep meeting state'
  },
  UseMember: {
    id: 'Sessions_UseMember',
    defaultMessage: 'Keep meeting members'
  },
  Organizer: {
    id: 'Sessions_Organizer',
    defaultMessage: 'Organizer : {name}'
  },
  Paticipant: {
    id: 'Sessions_Paticipant',
    defaultMessage: 'Paticipants : {count} people'
  },
  JoinFromQRCode: {
    id: 'Sessions_JoinFromQRCode',
    defaultMessage: 'Join the room'
  },
  PlaceByQRCode: {
    id: 'Sessions_PlaceByQRCode',
    defaultMessage: 'Place assets using QR code'
  },
  ToolsAddFile: {
    id: 'Sessions_ToolsAddFile',
    defaultMessage: 'Add file'
  },
  ToolsDelete: {
    id: 'Sessions_ToolsDelete',
    defaultMessage: 'Delete'
  },
  ToolsDownload: {
    id: 'Sessions_ToolsDownload',
    defaultMessage: 'Download'
  },
  ToolsDownloading: {
    id: 'Sessions_ToolsDownloading',
    defaultMessage: 'Downloading'
  },
  ToolsDownloadDescription: {
    id: 'Sessions_ToolsDownloadDescription',
    defaultMessage: 'Permission from the organizer is required to download files.'
  },
  ToolsAllowDL: {
    id: 'Sessions_ToolsAllowDL',
    defaultMessage: 'Allow DL'
  },
  ToolsDenyDL: {
    id: 'Sessions_ToolsDenyDL',
    defaultMessage: 'Deny DL'
  },
  ToolsChangeLog: {
    id: 'Sessions_ToolsChangeLog',
    defaultMessage: 'Activities'
  },
  ToolsAuthoring: {
    id: 'Sessions_ToolsAuthoring',
    defaultMessage: 'Authoring'
  },
  ToolsGrouping: {
    id: 'Sessions_ToolsGrouping',
    defaultMessage: 'Grouping'
  },
  NoRoomSelected: {
    id: 'Sessions_NoRoomSelected',
    defaultMessage: 'No room selected.'
  },
  NoFiles: {
    id: 'Sessions_NoFiles',
    defaultMessage: 'The file does not exist yet. Please upload the file by "Add file" or drag and drop.'
  },
  RegardingFileSize: {
    id: 'Sessions_RegardingFileSize',
    defaultMessage: 'Regarding file size'
  },
  StreamingMessage: {
    id: 'Sessions_StreamingMessage',
    defaultMessage: 'SpereCast：The remaining available delivery time for this month is {time}.'
  },
  StreamingWarning: {
    id: 'Sessions_StreamingWarning',
    defaultMessage: 'SpereCast：You have exceeded the available delivery time for this month.'
  }
});
export var Terrain = defineMessages({
  Title: {
    id: 'Terrain_Title',
    defaultMessage: 'Generate terrain data'
  }
});
export var Portal = defineMessages({
  Title: {
    id: 'Portal_Title',
    defaultMessage: 'Generate portal data'
  },
  DesticationOptionsNone: {
    id: 'Portal_DesticationOptionsNone',
    defaultMessage: 'Please select a room'
  },
  PrivateModeOnly: {
    id: 'Portal_PrivateModeOnly',
    defaultMessage: 'Automatically switch to private mode'
  }
});
export var Streaming = defineMessages({
  AddTitle: {
    id: 'Streaming_AddTitle',
    defaultMessage: 'Set up SphereCast'
  },
  SettingTitle: {
    id: 'Streaming_SettingTitle',
    defaultMessage: 'Set up SphereCast'
  },
  CopyUrl: {
    id: 'Streaming_CopyUrl',
    defaultMessage: 'Copy URL'
  },
  Description_1: {
    id: 'Streaming_Description_1',
    defaultMessage: '* You can use SphereCast for a total of 10 hours per month.'
  },
  Description_2: {
    id: 'Streaming_Description_2',
    defaultMessage: '  Remaining delivery time will be automatically reset in the next month.'
  },
  StreamingWarning: {
    id: 'Streaming_StreamingWarning',
    defaultMessage: 'Cannot be used because the monthly usage time has been exceeded'
  },
  StreamingAllreadySetup: {
    id: 'Streaming_StreamingAllreadySetup',
    defaultMessage: 'SphereCast is already set up'
  }
});
export var Thumbnail = defineMessages({
  Title: {
    id: 'Thumbnail_Title',
    defaultMessage: 'Change thumbnail'
  },
  Default: {
    id: 'Thumbnail_Default',
    defaultMessage: 'Default'
  }
});
export var User = defineMessages({
  Title: {
    id: 'User_Title',
    defaultMessage: 'User'
  }
});
export var Users = defineMessages({
  Title: {
    id: 'Users_Title',
    defaultMessage: 'Users'
  }
});
export var UserGroup = defineMessages({
  Title: {
    id: 'UserGroup_Title',
    defaultMessage: 'Group'
  }
});
export var UserGroups = defineMessages({
  Title: {
    id: 'UserGroups_Title',
    defaultMessage: 'Groups'
  }
});
export var UserGroupMemberSelection = defineMessages({
  Title: {
    id: 'UserGroupMemberSelection_Title',
    defaultMessage: 'Group member selection'
  }
});
export var Avatar = defineMessages({
  Title: {
    id: 'Avatar_Title',
    defaultMessage: 'Change avatar'
  },
  Default: {
    id: 'Avatar_Default',
    defaultMessage: 'Default'
  }
});
export var Capture = defineMessages({
  Title: {
    id: 'Capture_Title',
    defaultMessage: 'Capture'
  }
});
export var Reduction = defineMessages({
  Title: {
    id: 'Reduction_Title',
    defaultMessage: 'Reduction'
  }
});
export var Statistics = defineMessages({
  Title: {
    id: 'Statistics_Title',
    defaultMessage: 'Statistics'
  },
  TimeAndDate: {
    id: 'Statistics_TimeAndDate',
    defaultMessage: 'Search Time & Date'
  },
  Options: {
    id: 'Statistics_Options',
    defaultMessage: 'Search Options'
  },
  IncludeDeleted: {
    id: 'Statistics_IncludeDeleted',
    defaultMessage: 'Include deleted organizations'
  },
  IncludeSuspended: {
    id: 'Statistics_IncludeSuspended',
    defaultMessage: 'Include suspended organizations'
  }
});
export var Sales = defineMessages({
  Title: {
    id: 'Sales_Title',
    defaultMessage: 'Sales Management'
  },
  YearsCounterSuffix: {
    id: 'Sales_YearsCounterSuffix',
    defaultMessage: 'Fiscal Year '
  },
  No: {
    id: 'Sales_No',
    defaultMessage: 'No'
  },
  OrganizationName: {
    id: 'Sales_OrganizationName',
    defaultMessage: 'Organization name'
  },
  Month04: {
    id: 'Sales_Month04',
    defaultMessage: 'April'
  },
  Month05: {
    id: 'Sales_Month05',
    defaultMessage: 'May'
  },
  Month06: {
    id: 'Sales_Month06',
    defaultMessage: 'June'
  },
  Month07: {
    id: 'Sales_Month07',
    defaultMessage: 'July'
  },
  Month08: {
    id: 'Sales_Month08',
    defaultMessage: 'August'
  },
  Month09: {
    id: 'Sales_Month09',
    defaultMessage: 'September'
  },
  Month10: {
    id: 'Sales_Month10',
    defaultMessage: 'October'
  },
  Month11: {
    id: 'Sales_Month11',
    defaultMessage: 'November'
  },
  Month12: {
    id: 'Sales_Month12',
    defaultMessage: 'April'
  },
  Month01: {
    id: 'Sales_Month01',
    defaultMessage: 'January'
  },
  Month02: {
    id: 'Sales_Month02',
    defaultMessage: 'February'
  },
  Month03: {
    id: 'Sales_Month03',
    defaultMessage: 'March'
  },
  Total: {
    id: 'Sales_TotalAmount',
    defaultMessage: 'Total amount'
  }
});
export var Placeholder = defineMessages({
  Digits: {
    id: 'Placeholder_Digits',
    defaultMessage: '{value} digits'
  },
  Letters: {
    id: 'Placeholder_Letters',
    defaultMessage: '{value} letters'
  },
  OptionLetters: {
    id: 'Placeholder_OptionLetters',
    defaultMessage: '{value} letters (option)'
  },
  MailAddress: {
    id: 'Placeholder_MailAddress',
    defaultMessage: 'Mail address'
  },
  SearchWord: {
    id: 'Placeholder_SearchWord',
    defaultMessage: 'Search keyword'
  },
  Thumbnail: {
    id: 'Placeholder_Thumbnail',
    defaultMessage: 'Default thumbnail'
  },
  StreamingLocation: {
    id: 'Placeholder_StreamingLocation',
    defaultMessage: '* Factory, etc'
  }
});
export var Options = defineMessages({
  All: {
    id: 'Options_All',
    defaultMessage: 'All'
  },
  None: {
    id: 'Options_None',
    defaultMessage: 'Not specified'
  },
  Select: {
    id: 'Options_Select',
    defaultMessage: 'Please select'
  }
});
export var Authorities = defineMessages({
  SystemAdmin: {
    id: 'Authorities_SystemAdmin',
    defaultMessage: 'System admin'
  },
  OrgAdmin: {
    id: 'Authorities_OrgAdmin',
    defaultMessage: 'Org admin'
  },
  User: {
    id: 'Authorities_User',
    defaultMessage: 'User'
  },
  Supporter: {
    id: 'Authorities_Supporter',
    defaultMessage: 'Support'
  },
  Guest: {
    id: 'Authorities_Guest',
    defaultMessage: 'Guest'
  }
});
export var Services = defineMessages({
  Enterprise: {
    id: 'Services_Enterprise',
    defaultMessage: 'Enterprise edition'
  },
  Starter: {
    id: 'Services_Starter',
    defaultMessage: 'Starter edition'
  }
});
export var Protocols = defineMessages({
  Udp: {
    id: 'Protocols_Udp',
    defaultMessage: 'UDP'
  },
  Tcp: {
    id: 'Protocols_Tcp',
    defaultMessage: 'TCP'
  },
  Wss: {
    id: 'Protocols_Wss',
    defaultMessage: 'Wss'
  }
});
export var EnableOptions = defineMessages({
  Disabled: {
    id: 'EnableOptions_Disabled',
    defaultMessage: 'Disabled'
  },
  Enabled: {
    id: 'EnableOptions_Enabled',
    defaultMessage: 'Enabled'
  }
});
export var UsageOptions = defineMessages({
  Suspended: {
    id: 'UsageOptions_Suspended',
    defaultMessage: 'Suspended'
  },
  InUse: {
    id: 'UsageOptions_InUse',
    defaultMessage: 'In use'
  }
});
export var OrganizationScopes = defineMessages({
  All: {
    id: 'OrganizationScopes_All',
    defaultMessage: 'All organizations'
  },
  OnlyThis: {
    id: 'OrganizationScopes_OnlyThis',
    defaultMessage: 'This organization only'
  }
});
export var Situations = defineMessages({
  Untreated: {
    id: 'Situations_Untreated',
    defaultMessage: 'Not processed'
  },
  Wait: {
    id: 'Situations_Wait',
    defaultMessage: 'Queued'
  },
  Processing: {
    id: 'Situations_Processing',
    defaultMessage: 'Processing'
  },
  Success: {
    id: 'Situations_Success',
    defaultMessage: 'Success'
  },
  Failure: {
    id: 'Situations_Failure',
    defaultMessage: 'Failure'
  },
  Cancel: {
    id: 'Situations_Cancel',
    defaultMessage: 'Cancel'
  },
  Uploading: {
    id: 'Situations_Uploading',
    defaultMessage: 'Uploading'
  }
});
export var StreamingSituations = defineMessages({
  Offline: {
    id: 'StreamingSituations_Offline',
    defaultMessage: 'Offline'
  },
  Live: {
    id: 'StreamingSituations_Live',
    defaultMessage: 'Live'
  },
  Archive: {
    id: 'StreamingSituations_Archive',
    defaultMessage: 'Archive'
  }
});
export var Informations = defineMessages({
  Title: {
    id: 'Informations_Title',
    defaultMessage: 'Notifications'
  },
  NoNotification: {
    id: 'Informations_NoNotification',
    defaultMessage: 'No notification'
  }
});
export var Information = defineMessages({
  Title: {
    id: 'Information_Title',
    defaultMessage: 'Notification'
  }
});
export var Install = defineMessages({
  Title: {
    id: 'Install_Title',
    defaultMessage: 'Install'
  },
  PcTitle: {
    id: 'Install_PcTitle',
    defaultMessage: 'PC version WHITEROOM installer'
  },
  PcApp: {
    id: 'Install_PcApp',
    defaultMessage: 'After downloading the file, follow the steps below to install it.'
  },
  VRPlusTitle: {
    id: 'Install_VRPlusTitle',
    defaultMessage: 'Download WHITEROOM VRPlus'
  },
  VRPlusApp: {
    id: 'Install_VRPlusApp',
    defaultMessage: 'After downloading the file, please configure as follows.'
  }
});
export var Actions = defineMessages({
  Upload: {
    id: 'Actions_Upload',
    defaultMessage: 'upload'
  },
  Download: {
    id: 'Actions_Download',
    defaultMessage: 'download'
  },
  Delete: {
    id: 'Actions_Delete',
    defaultMessage: 'delete'
  },
  Copy: {
    id: 'Actions_Copy',
    defaultMessage: 'copy'
  }
});
export var MaterialHistory = defineMessages({
  Title: {
    id: 'MaterialHistory_Title',
    defaultMessage: 'Changelog'
  }
});
export var ActionsHistory = defineMessages({
  Title: {
    id: 'ActionsHistory_Title',
    defaultMessage: 'Activities'
  },
  NoActivity: {
    id: 'ActionsHistory_NoActivity',
    defaultMessage: 'No activity.'
  }
});
export var Authoring = defineMessages({
  Title: {
    id: 'Authoring_Title',
    defaultMessage: 'Authoring'
  }
});
export var AuthoringSequence = defineMessages({
  Title: {
    id: 'AuthoringSequence_Title',
    defaultMessage: 'Edit sequence'
  },
  NoAuthoring: {
    id: 'AuthoringSequence_NoAuthoring',
    defaultMessage: 'No sequence.'
  },
  SequenceGroupDefaultPrefix: {
    id: 'AuthoringSequence_SequenceGroupDefaultPrefix',
    defaultMessage: 'Group'
  },
  SequenceGroupDefaultPostfix: {
    id: 'AuthoringSequence_SequenceGroupDefaultPostfix',
    defaultMessage: '(AutoStart)'
  },
  DuplicateSequenceGroup: {
    id: 'AuthoringSequence_DuplicateSequenceGroup',
    defaultMessage: 'Copy of {name}'
  }
});
export var AuthoringInteraction = defineMessages({
  Title: {
    id: 'AuthoringInteraction_Title',
    defaultMessage: 'Edit interaction'
  },
  NoAuthoring: {
    id: 'AuthoringInteraction_NoAuthoring',
    defaultMessage: 'No interaction.'
  }
});
export var AuthoringEmpty = defineMessages({
  Title: {
    id: 'AuthoringEmpty_Title',
    defaultMessage: 'Add trigger object'
  }
});
export var AuthoringEffect = defineMessages({
  Title: {
    id: 'AuthoringEffect_Title',
    defaultMessage: 'Add effect'
  }
});
export var AuthoringTextPanel = defineMessages({
  Title: {
    id: 'AuthoringTextPanel_Title',
    defaultMessage: 'Add text panel'
  }
});
export var AuthoringMessage = defineMessages({
  Title: {
    id: 'AuthoringMessage_Title',
    defaultMessage: 'Manage message'
  },
  NoMessage: {
    id: 'AuthoringMessage_NoMessage',
    defaultMessage: 'No message.'
  },
  MakeQuiz: {
    id: 'AuthoringMessage_MakeQuiz',
    defaultMessage: 'Make Quiz'
  },
  RetryUntilCorrect: {
    id: 'AuthoringMessage_RetryUntilCorrect',
    defaultMessage: 'Retry until correct'
  },
  NoCorrectAnswer: {
    id: 'AuthoringMessage_NoCorrectAnswer',
    defaultMessage: 'Please add your choices. Please select at least one correct answer.'
  }
});
export var AuthoringDataPanel = defineMessages({
  Title: {
    id: 'AuthoringDataPanel_Title',
    defaultMessage: 'Manage data panels'
  },
  NoDataPanel: {
    id: 'AuthoringDataPanel_NoDataPanel',
    defaultMessage: 'No data panels'
  },
  DisconnectedMessage: {
    id: 'AuthoringDataPanel_DisconnectedMessage',
    defaultMessage: '[Enter the acquisition URL and login information to acquire data]'
  },
  AcquisitionFrequencySecond: {
    id: 'AuthoringDataPanel_AcquisitionFrequencySecond',
    defaultMessage: 'Every {time} second'
  },
  AcquisitionFrequencyMinite: {
    id: 'AuthoringDataPanel_AcquisitionFrequencySecond',
    defaultMessage: 'Every {time} minite'
  }
});
export var AuthoringMemo = defineMessages({
  Title: {
    id: 'AuthoringMemo_Title',
    defaultMessage: 'Memo'
  }
});
export var AuthoringConfirm = defineMessages({
  ErrorTitle: {
    id: 'AuthoringConfirm_ErrorTitle',
    defaultMessage: 'Error'
  },
  ErrorMessage: {
    id: 'AuthoringConfirm_ErrorMessage',
    defaultMessage: 'An incorrect part was found in the authoring syntax.\nSee the error message for each {type} for more information.\n* {type} with errors will not be executed in the app.'
  },
  ConfirmTitle: {
    id: 'AuthoringConfirm_ConfirmTitle',
    defaultMessage: 'Confirm'
  },
  ConfirmMessage: {
    id: 'AuthoringConfirm_ConfirmMessage',
    defaultMessage: 'The settings have changed.\nWhen you close the dialog, your changes will be cancelled.\nis it OK?'
  },
  SequenceGroupDeleteConfirmTitle: {
    id: 'AuthoringConfirm_SequenceGroupDeleteConfirmTitle',
    defaultMessage: 'Delete scenario group'
  },
  SequenceGroupDeleteConfirmWarningMessage: {
    id: 'AuthoringConfirm_SequenceGroupDeleteConfirmWarningMessage',
    defaultMessage: 'This scenario group is specified as the destination.'
  },
  SequenceGroupDeleteConfirmMessage: {
    id: 'AuthoringConfirm_SequenceGroupDeleteConfirmMessage',
    defaultMessage: 'Do you want to delete the selected scenario group?'
  },
  SequenceGroupRenameInputTitle: {
    id: 'AuthoringConfirm_SequenceGroupRenameInputTitle',
    defaultMessage: 'Rename scenario group'
  },
  SequenceGroupDuplicateInputTitle: {
    id: 'AuthoringConfirm_SequenceGroupDuplicateInputTitle',
    defaultMessage: 'Duplicate scenario group'
  },
  SequenceGroupCreateNewInputTitle: {
    id: 'AuthoringConfirm_SequenceGroupCreateNewInputTitle',
    defaultMessage: 'Create new scenario group'
  }
});
export var Regenarate = defineMessages({
  Title: {
    id: 'Regenarate_Title',
    defaultMessage: 'Regenarate PIN'
  }
});
export var SequenceSorts = defineMessages({
  None: {
    id: 'SequenceSorts_None',
    defaultMessage: 'Sort order'
  },
  TriggerAz: {
    id: 'SequenceSorts_TriggerAz',
    defaultMessage: 'Trigger : A->Z'
  },
  TriggerZa: {
    id: 'SequenceSorts_TriggerZa',
    defaultMessage: 'Trigger : Z->A'
  },
  TargetAz: {
    id: 'SequenceSorts_TargetAz',
    defaultMessage: 'Target : A->Z'
  },
  TargetZa: {
    id: 'SequenceSorts_TargetZa',
    defaultMessage: 'Target : Z->A'
  }
});
export var SessionActions = defineMessages({
  SessionCreated: {
    id: 'SessionActions_SessionCreated',
    defaultMessage: '{user} created the meeting state.'
  },
  SessionUpdated: {
    id: 'SessionActions_SessionUpdated',
    defaultMessage: '{user} updated the meeting state.'
  },
  SessionDeleted: {
    id: 'SessionActions_SessionDeleted',
    defaultMessage: '{user} removed the meeting state.'
  },
  SessionCopied: {
    id: 'SessionActions_SessionCopied',
    defaultMessage: '{user} copied the meeting state.'
  },
  SessionSaved: {
    id: 'SessionActions_SessionSaved',
    defaultMessage: '{user} saved the meeting state.'
  },
  SessionLoaded: {
    id: 'SessionActions_SessionLoaded',
    defaultMessage: '{user} restored the meeting state.'
  },
  MaterialAdded: {
    id: 'SessionActions_MaterialAdded',
    defaultMessage: '{user} added {material}.'
  },
  MaterialUpdated: {
    id: 'SessionActions_MaterialUpdated',
    defaultMessage: '{user} updated {material}.'
  },
  MaterialDeleted: {
    id: 'SessionActions_MaterialDeleted',
    defaultMessage: '{user} removed {material}.'
  },
  MaterialDownloaded: {
    id: 'SessionActions_MaterialDownloaded',
    defaultMessage: '{user} downloaded {material}.'
  },
  MaterialCopied: {
    id: 'SessionActions_MaterialCopied',
    defaultMessage: '{user} copied {material}.'
  },
  MemberAdded: {
    id: 'SessionActions_MemberAdded',
    defaultMessage: '{user} was added to the meeting.'
  },
  MemberDeleted: {
    id: 'SessionActions_MemberDeleted',
    defaultMessage: '{user} was removed from the meeting.'
  },
  MemberJoined: {
    id: 'SessionActions_MemberJoined',
    defaultMessage: '{user} joined the meeting.'
  },
  MemberExited: {
    id: 'SessionActions_MemberExited',
    defaultMessage: '{user} left the meeting.'
  },
  MemberCopied: {
    id: 'SessionActions_MemberCopied',
    defaultMessage: '{user} was copied to the room.'
  },
  CaptureCreated: {
    id: 'SessionActions_CaptureCreated',
    defaultMessage: '{user} took a capture.'
  },
  CaptureDeleted: {
    id: 'SessionActions_CaptureDeleted',
    defaultMessage: '{user} removed a capture.'
  },
  BroadcastStarted: {
    id: 'SessionActions_BroadcastStarted',
    defaultMessage: '{user} started broadcasting their view.'
  },
  BroadcastEnded: {
    id: 'SessionActions_BroadcastEnded',
    defaultMessage: '{user} finished broadcasting their view.'
  },
  ScreenSharingStarted: {
    id: 'SessionActions_ScreenSharingStarted',
    defaultMessage: '{user} started sharing their screen.'
  },
  ScreenSharingEnded: {
    id: 'SessionActions_ScreenSharingEnded',
    defaultMessage: '{user} finished sharing their screen.'
  },
  AuthoringEdit: {
    id: 'SessionActions_AuthoringEdit',
    defaultMessage: '{user} switched authoring to edit mode.'
  },
  AuthoringPlay: {
    id: 'SessionActions_AuthoringPlay',
    defaultMessage: '{user} switched authoring to play mode'
  },
  AuthoringNext: {
    id: 'SessionActions_AuthoringNext',
    defaultMessage: '{user} advanced the sequence. {memo}'
  },
  AuthoringBack: {
    id: 'SessionActions_AuthoringBack',
    defaultMessage: '{user} returned the sequence. {memo}'
  },
  AuthoringReset: {
    id: 'SessionActions_AuthoringReset',
    defaultMessage: '{user} reset the sequence.'
  },
  AuthoringSelect: {
    id: 'SessionActions_AuthoringSelect',
    defaultMessage: '{user} selected in sequence. {memo}'
  },
  AuthoringAnswer: {
    id: 'SessionActions_AuthoringAnswer',
    defaultMessage: '{user} answered in sequence. {memo}'
  },
  StreamingStarted: {
    id: 'SessionActions_StreamingStarted',
    defaultMessage: '{user} started SphereCast.'
  },
  StreamingEnded: {
    id: 'SessionActions_StreamingEnded',
    defaultMessage: '{user} finished SphereCast. Streaming time: {memo}'
  },
  VoiceMemoCreated: {
    id: 'SessionActions_VoiceMemoCreated',
    defaultMessage: '{user} created voice memo for {material}. {memo}'
  },
  StickyNoteCreated: {
    id: 'SessionActions_StickyNoteCreated',
    defaultMessage: '{user} created stickynote. {memo}'
  },
  StickyNoteUpdated: {
    id: 'SessionActions_StickyNoteUpdated',
    defaultMessage: '{user} updated stickynote. {memo}'
  },
  TranslationSpoken: {
    id: 'SessionActions_TranslationSpoken',
    defaultMessage: '{user} has spoken. {memo}'
  },
  ChatBotSpoken: {
    id: 'SessionActions_ChatBotSpoken',
    defaultMessage: '{user} asked {material} a question. {memo}'
  }
});
export var SequenceObject = defineMessages({
  Empty: {
    id: 'SequenceObject_Empty',
    defaultMessage: 'Trigger object'
  },
  User: {
    id: 'SequenceObject_User',
    defaultMessage: 'User'
  },
  UploadFiles: {
    id: 'SequenceObject_UploadFiles',
    defaultMessage: 'Upload files'
  },
  Effect: {
    id: 'SequenceObject_Effect',
    defaultMessage: 'Effect'
  },
  Controller: {
    id: 'SequenceObject_Controller',
    defaultMessage: 'Controller'
  },
  DataPanel: {
    id: 'SequenceObject_DataPanel',
    defaultMessage: 'Data panel'
  },
  Hand: {
    id: 'SequenceObject_Hand',
    defaultMessage: 'Hand'
  },
  Wait: {
    id: 'SequenceObject_Wait',
    defaultMessage: 'Wait(ms)'
  },
  ScenarioGroup: {
    id: 'SequenceObject_ScenarioGroup',
    defaultMessage: 'Scenario group'
  }
});
export var SequenceTriggers = defineMessages({
  Tap: {
    id: 'SequenceTriggers_Tap',
    defaultMessage: 'If you tap'
  },
  TapAgain: {
    id: 'SequenceTriggers_TapAgain',
    defaultMessage: 'if you tap again'
  },
  Gaze: {
    id: 'SequenceTriggers_Gaze',
    defaultMessage: 'If you gaze'
  },
  Proximity: {
    id: 'SequenceTriggers_Proximity',
    defaultMessage: 'If you collides'
  },
  Leave: {
    id: 'SequenceTriggers_Leave',
    defaultMessage: 'If you leave'
  },
  Auto: {
    id: 'SequenceTriggers_Auto',
    defaultMessage: "When it's your turn"
  },
  Hand: {
    id: 'SequenceTriggers_Hand',
    defaultMessage: "If your hand collides"
  },
  Data: {
    id: 'SequenceTriggers_Data',
    defaultMessage: "If you receive data"
  }
});
export var SequenceActions = defineMessages({
  VisibilityOn: {
    id: 'SequenceActions_VisibilityOn',
    defaultMessage: 'Is displayed'
  },
  VisibilityOff: {
    id: 'SequenceActions_VisibilityOff',
    defaultMessage: 'Is hidden'
  },
  PlayOn: {
    id: 'SequenceActions_PlayOn',
    defaultMessage: 'Is played'
  },
  PlayOff: {
    id: 'SequenceActions_PlayOff',
    defaultMessage: 'Is stopped'
  },
  VoiceMemoOn: {
    id: 'SequenceActions_VoiceMemoOn',
    defaultMessage: 'Voice memo is displayed'
  },
  VoiceMemoOff: {
    id: 'SequenceActions_VoiceMemoOff',
    defaultMessage: 'Voice memo is hidden'
  },
  Reset: {
    id: 'SequenceActions_Reset',
    defaultMessage: 'Rotation is reset'
  },
  Rollback: {
    id: 'SequenceActions_Rollback',
    defaultMessage: 'Status is reset'
  },
  Scale: {
    id: 'SequenceActions_Scale',
    defaultMessage: 'Scale changes'
  },
  ScaleReset: {
    id: 'SequenceActions_ScaleReset',
    defaultMessage: 'Scale resets'
  },
  LockOn: {
    id: 'SequenceActions_LockOn',
    defaultMessage: 'Is locked'
  },
  LockOff: {
    id: 'SequenceActions_LockOff',
    defaultMessage: 'Is unlocked'
  },
  GravityOn: {
    id: 'SequenceActions_GravityOn',
    defaultMessage: 'Gravity turns on'
  },
  GravityOff: {
    id: 'SequenceActions_GravityOff',
    defaultMessage: 'Gravity turns off'
  },
  ChatBotOn: {
    id: 'SequenceActions_ChatBotOn',
    defaultMessage: 'Conversation turns on'
  },
  ChatBotOff: {
    id: 'SequenceActions_ChatBotOff',
    defaultMessage: 'Conversation turns off'
  },
  ImmersiveOn: {
    id: 'SequenceActions_ImmersiveOn',
    defaultMessage: 'Immersive turns on'
  },
  ImmersiveOff: {
    id: 'SequenceActions_ImmersiveOff',
    defaultMessage: 'Immersive turns off'
  },
  Gather: {
    id: 'SequenceActions_Gather',
    defaultMessage: 'Gather users in'
  },
  NextPage: {
    id: 'SequenceActions_NextPage',
    defaultMessage: 'To next page'
  },
  Vibration: {
    id: 'SequenceActions_Vibration',
    defaultMessage: 'Vibrates'
  },
  Wait: {
    id: 'SequenceActions_Wait',
    defaultMessage: 'Wait(ms)'
  },
  SwitchGroupOn: {
    id: 'SequenceActions_SwitchGroupOn',
    defaultMessage: 'Switch on'
  },
  SwitchGroupOff: {
    id: 'SequenceActions_SwitchGroupOff',
    defaultMessage: 'Switch off'
  },
  CurrentlySelected: {
    id: 'SequenceActions_CurrentlySelected',
    defaultMessage: 'Currently selected file'
  },
  SameAsAbove: {
    id: 'SequenceActions_SameAsAbove',
    defaultMessage: 'Same as above'
  },
  DoNothing: {
    id: 'SequenceActions_DoNothing',
    defaultMessage: 'Do nothing'
  }
});
export var SequenceActionVibrationIntensity = defineMessages({
  Weak: {
    id: 'SequenceActionVibrationIntensity_Weak',
    defaultMessage: 'Weak'
  },
  Medium: {
    id: 'SequenceActionVibrationIntensity_Medium',
    defaultMessage: 'Medium'
  },
  Strong: {
    id: 'SequenceActionVibrationIntensity_Strong',
    defaultMessage: 'Strong'
  }
});
export var PresetScenarioGroup = defineMessages({
  CurrentTop: {
    id: 'PresetScenarioGroup_CurrentTop',
    defaultMessage: 'Return to Current Group'
  },
  PreviousTop: {
    id: 'PresetScenarioGroup_PreviousTop',
    defaultMessage: 'Return to Previous Group'
  },
  PreviousBranch: {
    id: 'PresetScenarioGroup_PreviousBranch',
    defaultMessage: 'Return to Previous Branch'
  }
});
export var SessionScenes = defineMessages({
  Title: {
    id: 'SessionScenes_Title',
    defaultMessage: 'Scene selection'
  },
  UploadTitle: {
    id: 'SessionScenes_UploadTitle',
    defaultMessage: 'Upload 360 degree image'
  },
  UploadDescription: {
    id: 'SessionScenes_UploadDescription',
    defaultMessage: 'Compatible formats : .exr,.hdr,.jpg,.jpeg,.png'
  }
});
export var SceneFilters = defineMessages({
  All: {
    id: 'SceneFilters_All',
    defaultMessage: 'All'
  },
  Room: {
    id: 'SceneFilters_Room',
    defaultMessage: 'Room'
  },
  _360DegreeImage: {
    id: 'SceneFilters_360DegreeImage',
    defaultMessage: '360 degree image'
  }
});
export var ServiceStatus = defineMessages({
  UnderContract: {
    id: 'ServiceStatus_UnderContract',
    defaultMessage: 'Under contract'
  },
  Deleted: {
    id: 'ServiceStatus_Deleted',
    defaultMessage: 'Deleted'
  },
  Suspended: {
    id: 'ServiceStatus_Suspended',
    defaultMessage: 'Suspended'
  }
});
export var OrganizationStatus = defineMessages({
  UnderContract: {
    id: 'OrganizationStatus_UnderContract',
    defaultMessage: 'Under contract'
  },
  Deleted: {
    id: 'OrganizationStatus_Deleted',
    defaultMessage: 'Deleted'
  },
  Suspended: {
    id: 'OrganizationStatus_Suspended',
    defaultMessage: 'Suspended'
  },
  NoContract: {
    id: 'OrganizationStatus_NoContract',
    defaultMessage: 'No Contract'
  },
  Trial: {
    id: 'OrganizationStatus_Trial',
    defaultMessage: 'Trial'
  },
  ScheduleContract: {
    id: 'OrganizationStatus_ScheduleContract',
    defaultMessage: 'Contract Schedule'
  }
});
export var NotifyStatus = defineMessages({
  NotNotified: {
    id: 'NotifyStatus_NotNotified',
    defaultMessage: 'Not notified'
  },
  Notified: {
    id: 'NotifyStatus_Notified',
    defaultMessage: 'Notified'
  },
  ReNotificationRequired: {
    id: 'NotifyStatus_ReNotificationRequired',
    defaultMessage: 'Renotification required'
  }
});
export var ConnectionStatus = defineMessages({
  Disconnected: {
    id: 'ConnectionStatus_Disconnected',
    defaultMessage: 'Not acquired'
  },
  Connected: {
    id: 'ConnectionStatus_Connected',
    defaultMessage: 'Acquired'
  },
  Error: {
    id: 'ConnectionStatus_Error',
    defaultMessage: 'Error'
  }
});
export var DataItemTypes = defineMessages({
  SimpleView: {
    id: 'DataItemTypes_SimpleView',
    defaultMessage: 'Simple view'
  },
  FractionView: {
    id: 'DataItemTypes_FractionView',
    defaultMessage: 'Fraction view'
  },
  FractionViewHorizontalGauge: {
    id: 'DataItemTypes_FractionViewHorizontalGauge',
    defaultMessage: 'Fraction view + horizontal gauge'
  },
  FractionViewVerticalGauge: {
    id: 'DataItemTypes_FractionViewVerticalGauge',
    defaultMessage: 'Fraction view + vertical gauge'
  },
  YearMonthDayHourMinuteSecondView: {
    id: 'DataItemTypes_YearMonthDayHourMinuteSecondView',
    defaultMessage: 'Year/month/day hour:minute:second view'
  },
  YearMonthDayHourMinuteView: {
    id: 'DataItemTypes_YearMonthDayHourMinuteView',
    defaultMessage: 'Year/month/day hour:minute view'
  },
  YearMonthDayView: {
    id: 'DataItemTypes_YearMonthDayView',
    defaultMessage: 'Year/month/day view'
  },
  OnOff: {
    id: 'DataItemTypes_OnOff',
    defaultMessage: 'ON/OFF view'
  },
  RadioView: {
    id: 'DataItemTypes_RadioView',
    defaultMessage: 'Radio view'
  },
  MaxMinView: {
    id: 'DataItemTypes_MaxMinView',
    defaultMessage: 'Max/Min view'
  }
});
export var SphereCast = defineMessages({
  Title: {
    id: 'SphereCast_Title',
    defaultMessage: 'SphereCast'
  }
});
export var SphereCastView = defineMessages({
  Insta360App: {
    id: 'SphereCastView_Insta360App',
    defaultMessage: 'Insta360 app'
  },
  OpenInsta360App: {
    id: 'SphereCastView_OpenInsta360App',
    defaultMessage: 'Open Insta360 app'
  },
  NoneMessage: {
    id: 'SphereCastView_NoneMessage',
    defaultMessage: 'Install the {app} and paste the link below on your smartphone/tablet connected to a 360-degree camera.'
  },
  GenerateMessage: {
    id: 'SphereCastView_GenerateMessage',
    defaultMessage: 'SphereCast can relay 360 degree video. Please issue a link to connect with the 360 ​​degree camera below.'
  },
  TutorialMessage_01: {
    id: 'SphereCastView_TutorialMessage_01',
    defaultMessage: 'When you connect the {app} and the 360-degree camera and set the shooting mode to "Live", "RTMP" will be displayed as shown below, so please select it.'
  },
  TutorialMessage_02: {
    id: 'SphereCastView_TutorialMessage_02',
    defaultMessage: 'The casting service selection screen will be displayed, so select "RTMP".'
  },
  TutorialMessage_03: {
    id: 'SphereCastView_TutorialMessage_03',
    defaultMessage: 'Paste the copied link and select "Start Live Stream".'
  },
  TutorialMessage_04: {
    id: 'SphereCastView_TutorialMessage_04',
    defaultMessage: 'When you return to the camera screen, select the casting quality settings button at the bottom right.'
  },
  TutorialMessage_05: {
    id: 'SphereCastView_TutorialMessage_05',
    defaultMessage: 'After confirming that the video quality (bitrate) of the distribution is 2M, please press the start casting button.'
  },
  TutorialMessage_06: {
    id: 'SphereCastView_TutorialMessage_06',
    defaultMessage: 'When the casting time is displayed, it is complete. After that, please take a look at the assets from Files in the WHITEROOM app.'
  },
  TutorialMessage_07_01: {
    id: 'SphereCastView_TutorialMessage_07_01',
    defaultMessage: 'Notes'
  },
  TutorialMessage_07_02: {
    id: 'SphereCastView_TutorialMessage_07_02',
    defaultMessage: '- During casting, monthly casting time will be consumed.'
  },
  TutorialMessage_07_03: {
    id: 'SphereCastView_TutorialMessage_07_03',
    defaultMessage: '- If the default time is exceeded, the casting will stop automatically.'
  },
  TutorialMessage_07_04: {
    id: 'SphereCastView_TutorialMessage_07_04',
    defaultMessage: '- The remaining casting time will be reset to the next month.'
  },
  TutorialMessage_07_05: {
    id: 'SphereCastView_TutorialMessage_07_05',
    defaultMessage: '- You can connect one 360-degree camera per casting link.'
  },
  TutorialMessage_07_06: {
    id: 'SphereCastView_TutorialMessage_07_06',
    defaultMessage: '- Currently, only one 360-degree live video can be viewed on WHITEROOM at a time.'
  },
  TutorialMessage_07_07: {
    id: 'SphereCastView_TutorialMessage_07_07',
    defaultMessage: '- The published link for casting cannot be used in other rooms. Please issue a new invitation email.'
  },
  QrCodeModalMessage: {
    id: 'SphereCastView_QrCodeModalMessage',
    defaultMessage: 'Please scan the QR code below with a smartphone/tablet that has the {app} installed and is connected to a 360-degree camera.'
  },
  DeleteModalTitle: {
    id: 'SphereCastView_DeleteModalTitle',
    defaultMessage: 'Do you want to remove the link below?'
  },
  HelpModalTitle: {
    id: 'SphereCastView_HelpModalTitle',
    defaultMessage: 'Regarding casting time'
  },
  HelpModalMessage: {
    id: 'SphereCastView_HelpModalMessage',
    defaultMessage: 'You can use SphereCast for a total of 10 hours per month.The remaining cast time will be automatically reset in the next month.'
  },
  EmptyModalTitle: {
    id: 'SphereCastView_EmptyModalTitle',
    defaultMessage: 'The remaining delivery time is now 0.'
  },
  EmptyModalMessage: {
    id: 'SphereCastView_EmptyModalMessage',
    defaultMessage: 'Distribution will be stopped because the monthly distribution time has been exceeded. The remaining delivery time will be automatically reset in the next month.'
  },
  CreatePublishLinkMessage: {
    id: 'SphereCastView_CreatePublishLinkMessage',
    defaultMessage: 'The Link for casting has been created'
  },
  CopyPublishLinkMessage: {
    id: 'SphereCastView_CopyPublishLinkMessage',
    defaultMessage: 'The link for casting has been copied'
  },
  RemovePublishLinkMessage: {
    id: 'SphereCastView_RemovePublishLinkMessage',
    defaultMessage: 'The link for castring has been removed'
  }
});
export var QuizResults = defineMessages({
  CorrectCase: {
    id: 'QuizResults_CorrectCase',
    defaultMessage: 'If correct'
  },
  IncorrectCase: {
    id: 'QuizResults_IncorrectCase',
    defaultMessage: 'If incorrect'
  }
});
export var CreateSphereGroup = defineMessages({
  Title: {
    id: 'CreateSphereGroup_Title',
    defaultMessage: 'Grouping 360° media'
  },
  TitleDescription: {
    id: 'CreateSphereGroup_TitleDescription',
    defaultMessage: 'Please enter a group name. (1-150 characters)'
  },
  TitleNotes: {
    id: 'CreateSphereGroup_TitleNotes',
    defaultMessage: '*Please note that the group name cannot be changed later.'
  },
  AssetsDescription: {
    id: 'CreateSphereGroup_AssetsDescription',
    defaultMessage: 'Check the assets you want to include in the group.'
  }
});
export var DeleteSphereGroup = defineMessages({
  Title: {
    id: 'DeleteSphereGroup_Title',
    defaultMessage: 'Delete group'
  },
  Message: {
    id: 'DeleteSphereGroup_Message',
    defaultMessage: 'Are you sure you want to delete the selected group?'
  }
});